import React from 'react';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';
import { FlexProps } from '@leagueplatform/genesis-commons';
import { ERROR_TYPES } from '../hooks/use-error-message/use-error-message';
import { ErrorState } from '../components/error/error-state.component';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  contextLocation: string;
  styleErrorProps?: FlexProps;
}

export const ErrorBoundary = ({
  children,
  contextLocation,
  styleErrorProps,
}: ErrorBoundaryProps) => (
  <ObservabilityErrorBoundary
    fallback={
      <ErrorState
        isFullPage
        errorType={ERROR_TYPES.API_ERROR}
        styleProps={styleErrorProps}
      />
    }
    errorContext={{
      context: {
        Context: { location: { contextLocation } },
      },
    }}
  >
    {children}
  </ObservabilityErrorBoundary>
);
